<script setup lang="ts">
import ReportExportToastItem from '@/js/components/ReportExport/ReportExportToastItem.vue'
import useReportExportQueue from '@/js/hooks/useReportExportQueue'

// One renderless poller per queued export, each one drives its own toast
const { exports } = useReportExportQueue()
</script>

<template>
    <ReportExportToastItem v-for="item in exports" :key="item.id" :item="item" />
</template>
